import { Provider } from '@angular/core';
import { PortalDataHttpService } from './abstract';
import { PortalDataHttpServiceImpl } from './portal-data-http.service';

export const PortalDataHttpProvider: Provider = {
	provide: PortalDataHttpService,
	useClass: PortalDataHttpServiceImpl,
};
